import { UpgradePlanSheet } from '@nile/components/src/Sheets'
import { Modal } from '@superops/ui-design-system'
import React from 'react'
import styled from 'styled-components'

const UpgradePlan = (props) => {
  const {
    active,
    handleClose,
    subscription,
    plans,
    tenure,
    currency,
    locale,
    setTenure,
    isTieredModel,
    planChange
  } = props

  return (
    <>
      <Modal
        fullScreen
        open={active}
        onClose={() => {
          handleClose(false)
          setTenure(subscription?.currentPlanPrice?.duration)
        }}
        showCloseButton={false}
      >
        <UpgradePlanSheet
          subscription={subscription}
          closeModal={handleClose}
          plans={plans}
          tenure={tenure}
          currency={currency}
          locale={locale}
          isTieredModel={isTieredModel}
          planChange={planChange}
        />
      </Modal>
    </>
  )
}

export default UpgradePlan
